import CXMApiClient from "../../CXMApiClient";

const state = {
  AddProspectConfirmationModal: {
    ShowModal: false,
    RequestPayload: null,
    StartShowroomVisit: false,
    ExistingContacts: []
  },
  AddLeadModal: {
    ShowModal: false,
    ContactId: null,
    AccountId: null,
    PlatformId: null,
    IsCanadianStore: false
  }
};

const getters = {};

const actions = {
  saveProspect(context, requestPayload) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/crm/prospect/add",
          requestPayload,
          requestPayload.accountPlatformId
            ? [requestPayload.accountPlatformId]
            : []
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  openAddProspectConfirmationModal(context, data) {
    context.commit("openAddProspectConfirmationModal", data);
  },
  closeAddProspectConfirmationModal(context) {
    context.commit("closeAddProspectConfirmationModal");
  },
  openAddLeadModal(context, data) {
    context.commit("openAddLeadModal", data);
  },
  closeAddLeadModal(context) {
    context.commit("closeAddLeadModal");
  }
};

const mutations = {
  openAddProspectConfirmationModal(state, data) {
    data.RequestPayload.skipContactProposal = true;
    state.AddProspectConfirmationModal.RequestPayload = data.RequestPayload;
    state.AddProspectConfirmationModal.StartShowroomVisit =
      data.StartShowroomVisit;
    state.AddProspectConfirmationModal.ExistingContacts = data.ExistingContacts;
    state.AddProspectConfirmationModal.ShowModal = true;
    state.AddProspectConfirmationModal.OpenAddHouseholdMemberModal = data.OpenAddHouseholdMemberModal;
  },
  closeAddProspectConfirmationModal(state) {
    state.AddProspectConfirmationModal.RequestPayload = null;
    state.AddProspectConfirmationModal.StartShowroomVisit = false;
    state.AddProspectConfirmationModal.ExistingContacts = null;
    state.AddProspectConfirmationModal.ShowModal = false;
    state.AddProspectConfirmationModal.OpenAddHouseholdMemberModal = false;
  },
  openAddLeadModal(state, data) {
    state.AddLeadModal.ContactId = data.ContactId;
    state.AddLeadModal.AccountId = data.AccountId;
    state.AddLeadModal.PlatformId = data.PlatformId;
    state.AddLeadModal.IsCanadianStore = data.IsCanadianStore;
    state.AddLeadModal.ShowModal = true;
  },
  closeAddLeadModal(state) {
    state.AddLeadModal.ShowModal = false;
    state.AddLeadModal.ContactId = null;
    state.AddLeadModal.AccountId = null;
    state.AddLeadModal.PlatformId = null;
    state.AddLeadModal.IsCanadianStore = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/contact/Prospect.js